"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const js_1 = __importDefault(require("@honeybadger-io/js"));
const browser_1 = __importDefault(require("@hyperdx/browser"));
const core_1 = require("@material-ui/core");
const colors_1 = require("@material-ui/core/colors");
const Info_1 = __importDefault(require("@material-ui/icons/Info"));
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_cookie_1 = require("react-cookie");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const config_1 = require("config");
const consumer_applications_v1_api_1 = require("consumer-applications-v1-api");
const context_1 = require("context");
const credit_portal_components_1 = require("credit-portal-components");
const hooks_1 = require("hooks");
const inline_colors_1 = require("inline-colors");
const utils_1 = require("utils");
const forms_1 = require("../../forms");
const api_1 = require("../../prove/views/utils/api");
const actions_1 = require("../actions");
const actions = __importStar(require("../actions"));
const reducer_1 = require("../reducer");
const PersonalInfo = ({ applicationEnvironment, onContinue, setPersonalInfo, practice, setLenderReferenceId, personalInfo, allowChangePractice, showFindApplication, creditApplication, setPrequalification, prequalification, clearPersonalInfo, }) => {
    // Hooks
    const dispatch = (0, react_redux_1.useDispatch)();
    const proveVerify = (0, react_redux_1.useSelector)(reducer_1.selectors.proveVerify);
    const proveFail = (0, react_redux_1.useSelector)(reducer_1.selectors.proveFail);
    const proveBypass = (0, react_redux_1.useSelector)(reducer_1.selectors.proveBypass);
    const history = (0, react_router_dom_1.useHistory)();
    const location = (0, react_router_dom_1.useLocation)();
    const { analytics } = (0, react_1.useContext)(context_1.AnalyticsContext);
    const [cookies] = (0, react_cookie_1.useCookies)(['proveAb', 'proveStoreAb', 'storeLinkCampaign']);
    // State
    const [sessionJson] = (0, react_1.useState)(proveVerify);
    const [sessionJsonFail] = (0, react_1.useState)(proveFail);
    const [formVals, setFormVals] = (0, react_1.useState)(undefined);
    const [isProvePrefilled, setIsProvePrefilled] = (0, react_1.useState)(false);
    const [proveSession, setProveSession] = (0, react_1.useState)(undefined);
    const [proveSessionFail, setProveSessionFail] = (0, react_1.useState)(undefined);
    const [isProveLoading, setIsProveLoading] = (0, react_1.useState)(false);
    const [isSubmittingForm, setIsSubmittingForm] = (0, react_1.useState)(false);
    const [getBlackboxData] = (0, hooks_1.useIovation)();
    // API
    const [patchApplicant] = (0, consumer_applications_v1_api_1.usePatchConsumerApplicationsV1CreditApplicationsApplicationIdMutation)();
    const [prequalifyCreditApplication] = (0, consumer_applications_v1_api_1.usePostConsumerApplicationsV1CreditApplicationsApplicationIdPrequalifyMutation)();
    const [requestPrequalification] = (0, consumer_applications_v1_api_1.usePostConsumerApplicationsV1PrequalificationsMutation)();
    // Vars
    const practiceFromState = location.state;
    const practiceToUse = !practice?.locationId && practiceFromState?.practice?.locationId
        ? practiceFromState.practice
        : practice;
    const handleAppRoutingByAppState = (creditAppStatus) => {
        if (creditAppStatus === 'prequalified') {
            history.push(config_1.APPLICATION_FINDER_URL);
        }
        else if (creditAppStatus === 'prequalified_account_exists') {
            history.push(config_1.PRE_QUALIFICATION_ACCOUNT_EXISTS_URL);
        }
        else if (creditAppStatus === 'pending_approval') {
            history.push(config_1.APPLICATION_FINDER_URL);
        }
        else {
            history.push(config_1.PRE_QUALIFICATION_DECLINED_URL);
            return;
        }
    };
    if (!(0, lodash_1.isNil)(creditApplication)) {
        const creditAppStatus = creditApplication.applicationStatus;
        if (creditAppStatus !== 'created') {
            handleAppRoutingByAppState(creditAppStatus);
        }
    }
    let payloadData = null;
    const attachProveData = () => {
        const proveAbParticipantUuid = practice
            ? cookies.proveStoreAb?.participantUuid
            : cookies.proveAb?.participantUuid;
        let proveBypassToUse = undefined;
        if (proveBypass) {
            proveBypassToUse = proveBypass;
        }
        else if (proveSession || proveSessionFail) {
            proveBypassToUse = false;
        }
        return {
            proveSessionId: proveSession ?? proveSessionFail ?? undefined,
            proveBypassed: proveBypassToUse,
            ...(proveAbParticipantUuid
                ? { abParticipantUuid: proveAbParticipantUuid }
                : {}),
        };
    };
    const handlePushAppSubmit = (prequalificationFormValues) => {
        const { alphaeonTerms, lenderTerms } = applicationEnvironment;
        const storeLinkCampaign = cookies.storeLinkCampaign;
        if (creditApplication.applicationStatus !== 'created') {
            handleAppRoutingByAppState(creditApplication.applicationStatus);
        }
        return patchApplicant({
            applicationId: creditApplication.applicationId,
            patchConsumerApplicationsV1CreditApplicationsApplicationId: {
                ...prequalificationFormValues,
                ...(storeLinkCampaign
                    ? {
                        storeLinkCampaign: storeLinkCampaign.campaignId,
                        otl: storeLinkCampaign.otl,
                    }
                    : {}),
                ...attachProveData(),
            },
        }).then((response) => {
            if ('data' in response) {
                const { consumer } = creditApplication.locationServiceProviderPriorities;
                const acPrimePriority = consumer.find(({ productType }) => productType === config_1.PRODUCT_TYPE.AC_PRIME);
                const prequalificationRequest = {
                    priority: acPrimePriority?.priority,
                    iovationBlackBox: getBlackboxData().blackbox,
                    prerequisiteTermsAccepted: (0, utils_1.approveTerms)(alphaeonTerms, lenderTerms),
                };
                payloadData = {
                    ...prequalificationRequest,
                    locationId: practice.locationId,
                    ...{
                        proveSessionId: proveSession ?? proveSessionFail ?? undefined,
                    },
                };
                return prequalifyCreditApplication({
                    applicationId: creditApplication.applicationId,
                    postConsumerApplicationsV1CreditApplicationsApplicationIdPrequalify: payloadData,
                }).then((response) => {
                    if ('data' in response) {
                        const prequalificationDataFix = response.data;
                        setPrequalification(prequalificationDataFix);
                        return { ...prequalificationDataFix };
                    }
                });
            }
        });
    };
    const handleSubmit = async (prequalificationFormValues) => {
        setPersonalInfo(prequalificationFormValues);
        browser_1.default.setGlobalAttributes({
            locationId: practiceToUse?.locationId.toString() || '',
            storeNumber: practiceToUse?.adsStoreNumber.toString() || '',
            creditApplicationId: creditApplication?.applicationId?.toString() || '',
            lastName: prequalificationFormValues.lastName,
            firstName: prequalificationFormValues.firstName,
            email: prequalificationFormValues.email,
            phone: prequalificationFormValues.primaryPhone,
            form: 'personal-info',
        });
        if (!(0, lodash_1.isNil)(creditApplication)) {
            return handlePushAppSubmit(prequalificationFormValues)
                .then((data) => {
                if (data) {
                    handleSubmitSuccess(data);
                }
                else {
                    setIsSubmittingForm(false);
                }
            })
                .catch((error) => {
                (0, utils_1.toastError)(`${error.response?.message ?? error}`);
                setIsSubmittingForm(false);
            });
        }
        else {
            const { alphaeonTerms, lenderTerms } = applicationEnvironment;
            const approvedTerms = (0, utils_1.approveTerms)(alphaeonTerms, lenderTerms);
            const query_params = new URLSearchParams(location.search);
            const partner_tracking_guid = query_params.get('partner_tracking_guid');
            const partner_identifier = query_params.get('partner_identifier');
            const blackboxData = getBlackboxData();
            const storeLinkCampaign = cookies.storeLinkCampaign;
            const data = {
                ...prequalificationFormValues,
                ...(practiceToUse && { locationId: practiceToUse.locationId }),
                iovationBlackBox: blackboxData.blackbox,
                prerequisiteTermsAccepted: approvedTerms,
                partner_tracking_guid: partner_tracking_guid,
                partner_identifier: partner_identifier,
                ...(storeLinkCampaign
                    ? {
                        storeLinkCampaign: storeLinkCampaign.campaignId,
                        otl: storeLinkCampaign.otl,
                    }
                    : {}),
                ...attachProveData(),
            };
            payloadData = data;
            if (isProvePrefilled) {
                // HyperDX Action
                (0, utils_1.reportAction)('ProveApp', {
                    componentName: 'PersonalInfo',
                    actionType: 'Sign Up',
                    actionURL: window.location.pathname,
                    actionData: {
                        ...data,
                        iovationBlackBox: undefined,
                    },
                });
            }
            dispatch((0, actions_1.clearProveBypass)()); // Clear Prove Bypass
            return requestPrequalification({
                postConsumerApplicationsV1Prequalifications: data,
            }).then((response) => {
                if ('data' in response) {
                    const prequalificationDataFix = response.data;
                    handleSubmitSuccess(prequalificationDataFix);
                    setPrequalification(prequalificationDataFix);
                }
                else {
                    setIsSubmittingForm(false);
                }
            });
        }
    };
    const handleSubmitSuccess = ({ applicationStatus, lenderNextStepUrl, lenderStatusMessage, applicationServiceProviderPriority, lenderRequestReferenceId, }) => {
        setLenderReferenceId(lenderRequestReferenceId);
        analytics?.track('SubmitApplication', {});
        // Prove post submit
        if (isProvePrefilled) {
            dispatch((0, actions_1.clearProveFail)()); // Clear Prove Fail
            dispatch((0, actions_1.clearProveVerify)()); // Clear Prove Verify
            // Only formVals were edited
            if (formVals) {
                if (sessionJson) {
                    (0, api_1.postProveVerifyApplicantData)({
                        session_id: sessionJson.session_id ||
                            (proveSession ? proveSession : proveSessionFail) ||
                            (proveSessionFail ? proveSessionFail : ''),
                        pre_fill_data: {
                            first_name: formVals.firstName,
                            last_name: formVals.lastName,
                            date_of_birth: formVals.dateOfBirth,
                            email: formVals.email,
                            address: {
                                address: formVals.street1,
                                address_extended: formVals.street2 ?? '',
                                city: formVals.city,
                                region: formVals.state,
                                zipcode: formVals.zip,
                            },
                        },
                    });
                }
            }
        }
        if (applicationStatus === 'prequalified') {
            onContinue(payloadData);
        }
        else if (applicationStatus === 'prequalified_account_exists') {
            history.push(config_1.PRE_QUALIFICATION_ACCOUNT_EXISTS_URL);
            clearPersonalInfo();
        }
        else if (applicationStatus === 'pending_approval') {
            // "An assumption is currently made that pending_approval is returned only for access loans. If additional product types associated with
            //  a pending_approval status will be supported, this code this have to be revisited to accommodate them."
            history.push({
                pathname: config_1.ACCESS_LOAN_URL,
                state: {
                    lenderNextStepUrl,
                    modalType: 'prequal',
                },
            });
        }
        else {
            if (applicationServiceProviderPriority?.productType === 'installment') {
                history.push(config_1.PRE_QUALIFICATION_DECLINED_URL);
                //prequalification declined for both
            }
            else {
                history.push({
                    pathname: config_1.PRE_QUALIFICATION_DECLINED_ADS_ONLY_URL,
                    state: {
                        lenderStatusMessage,
                    },
                });
                //prequalification declined for Bread only
                //DeclinedPage
            }
            setIsSubmittingForm(false);
            return;
        }
        setIsSubmittingForm(false);
    };
    const handleChangeLocation = () => {
        history.push(config_1.CREDIT_PORTAL_URL);
    };
    /**
     * @desc Prove identity verification here
     */
    /**
     * @name init
     * @desc Check if Prove is available, if so get the PreFill data and load the form via redux
     */
    const init = async () => {
        setIsProveLoading(true);
        let getPreFillData;
        if (sessionJson && sessionJson.session_id === null) {
            getPreFillData = api_1.getProvePreFillOTA;
        }
        else if (sessionJson && sessionJson.session_id) {
            getPreFillData = api_1.getProvePreFill;
        }
        if (sessionJson && getPreFillData) {
            const preFillJson = await getPreFillData(sessionJson);
            const preFillRes = await preFillJson?.json();
            setProveSession(sessionJson.session_id ?? preFillRes.session_id); // Set Prove Session no matter what
            if (preFillRes?.message !== 'Prove pre-fill already used.' &&
                preFillRes?.message !== 'No CRM data available' &&
                preFillRes?.error_code === undefined) {
                setIsProvePrefilled(true); // Set Prove Bool
                setPersonalInfo({
                    street1: preFillRes.address.address,
                    street2: preFillRes.address.address_extended,
                    city: preFillRes.address.city,
                    dateOfBirth: preFillRes.date_of_birth,
                    email: preFillRes.email,
                    firstName: preFillRes.first_name,
                    lastName: preFillRes.last_name,
                    primaryPhone: sessionJson.phone_number,
                    ...(preFillRes.ssn_last_4
                        ? { ssn: `XXXXX${preFillRes.ssn_last_4}` }
                        : {}),
                    state: preFillRes.address.region,
                    zip: preFillRes.address.zipcode,
                }); // set pre-fill data
            }
            else {
                setIsProveLoading(false); // Stop loader
                dispatch((0, actions_1.setProveFail)({
                    ...sessionJson,
                }));
                // Clear Prove Verify/App
                dispatch((0, actions_1.clearProveVerify)());
                dispatch((0, actions_1.clearProveApp)());
                /* Show possible fail message Here */
                /* KEEP - PREFILL WHAT WE CAN ? */
                setPersonalInfo({
                    primaryPhone: (sessionJson && sessionJson.phone_number) ?? '',
                });
                // Redirect if no prefill available or error
                history.push({
                    pathname: '/credit-portal/apply/wizard',
                    search: location.search,
                });
            }
        }
        else {
            //
        }
        setProveSessionFail(sessionJson?.session_id ?? sessionJsonFail?.session_id); // Set Prove Session ID no matter what
        setIsProveLoading(false); // Stop loader
    };
    // Effects
    (0, react_1.useEffect)(() => {
        analytics?.track('WizardSessionStart', {});
        if (config_1.PATH.PROVE !== null) {
            init();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (prequalification) {
            js_1.default.setContext({
                creditApplicationId: prequalification.applicationId,
            });
        }
    }, [prequalification]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "application-instructions", children: [(0, jsx_runtime_1.jsxs)("div", { className: "info-header", children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Find out now if you ", (0, jsx_runtime_1.jsx)("span", { children: "pre-qualify" }), (0, jsx_runtime_1.jsx)("sup", { children: "**" }), " without impacting your credit."] }), (0, jsx_runtime_1.jsx)("p", { children: "It's quick, easy, and secure with instant results, including your credit limit." })] }), (0, jsx_runtime_1.jsxs)("ul", { className: "info-content", children: [practiceToUse &&
                        practiceToUse.name &&
                        practiceToUse.locationId &&
                        !window.location.host.includes('iframe') && ((0, jsx_runtime_1.jsxs)("li", { className: "info", children: [creditApplication && personalInfo ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("b", { children: practiceToUse.name }), " has sent a one-time pre-qualification form for ", personalInfo.firstName, ' ', personalInfo.lastName, "."] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["You've selected practice ", (0, jsx_runtime_1.jsx)("b", { children: practiceToUse.name }), "."] })), allowChangePractice && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["If this is incorrect,", ' ', (0, jsx_runtime_1.jsx)("button", { onClick: handleChangeLocation, children: "click here" }), " to find a different practice."] }))] })), (0, jsx_runtime_1.jsxs)("li", { children: ["If your credit is locked or frozen, you'll need to remove the freeze before applying.", (0, jsx_runtime_1.jsx)("div", { className: "tooltip-container", children: (0, jsx_runtime_1.jsx)(core_1.Tooltip, { enterTouchDelay: 0, placement: "left", title: (0, jsx_runtime_1.jsx)("p", { style: {
                                            fontSize: '14px',
                                            color: inline_colors_1.INLINE_COLORS.whiteBase,
                                        }, children: "If you placed a freeze on your credit file, please contact each credit reporting agency directly to remove the credit freeze before going through the apply process." }), children: (0, jsx_runtime_1.jsx)(core_1.IconButton, { className: "icon-button", children: (0, jsx_runtime_1.jsx)(Info_1.default, { style: { color: colors_1.blue[800] } }) }) }) })] }), showFindApplication && ((0, jsx_runtime_1.jsxs)("li", { children: ["If you have already started an application and would like to complete it, please", ' ', (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: config_1.APPLICATION_FINDER_URL, children: "click here" }), "."] }))] }), (0, jsx_runtime_1.jsx)(forms_1.PrefilledPersonalInfoForm, { data: personalInfo, handleSubmit: handleSubmit, practice: practice, isProvePrefilled: isProvePrefilled, setFormVals: setFormVals, isProveLoading: isProveLoading, fieldsToExclude: applicationEnvironment.fieldsToExclude, showAdditionalTerms: applicationEnvironment.showAdditionalTerms, isSubmittingForm: isSubmittingForm, setIsSubmittingForm: setIsSubmittingForm }), (0, jsx_runtime_1.jsx)(credit_portal_components_1.ServiceProviderDisclosures, {})] }));
};
function mapStateToProps(state) {
    return {
        applicationEnvironment: reducer_1.selectors.applicationEnvironment(state),
        practice: reducer_1.selectors.practice(state),
        personalInfo: reducer_1.selectors.personalInfo(state),
        creditApplication: reducer_1.selectors.creditApplication(state),
    };
}
const mapDispatchToProps = {
    setPersonalInfo: actions.setPersonalInfo,
    clearPersonalInfo: actions.clearPersonalInfo,
    setLenderReferenceId: actions.setLenderReferenceId,
    setPrequalification: actions.setPrequalification,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps))(PersonalInfo);
